/**
 * The results page's collections group. A36.
 *
 * Liquid's search object returns products, pages and articles — never
 * collections. Predictive search does, so the "Collections & occasions" group
 * is asked for once the page is up and rendered only if there is something to
 * put in it. An empty group does not render.
 */

const page = document.querySelector('[data-search-page]');
const group = page?.querySelector('[data-search-collections]');
const list = page?.querySelector('[data-search-collections-list]');
const terms = page?.dataset.terms?.trim();

if (group && list && terms) {
  const root = window.Shopify?.routes?.root || '/';
  fetch(`${root}search/suggest.json?q=${encodeURIComponent(terms)}&resources[type]=collection&resources[limit]=4`)
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      const found = data?.resources?.results?.collections || [];
      if (found.length === 0) return;
      list.replaceChildren(
        ...found.map((c) => {
          const a = document.createElement('a');
          a.className = 'search-list__item';
          a.href = c.url;
          const text = document.createElement('span');
          text.className = 'search-list__text';
          const name = document.createElement('span');
          name.className = 'search-list__name';
          name.textContent = c.title;
          text.append(name);
          a.append(text);
          return a;
        })
      );
      group.hidden = false;
    })
    .catch(() => {});
}
